import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faPause,
  faVolumeMute,
  faVolumeUp,
  faCog,
  faExpand,
  faCompress,
  faForward,
  faDownload,
  faForwardStep,
} from '@fortawesome/free-solid-svg-icons';
import PageHeading from "../common/PageHeading";
import "./Videoplayer.css"
import BackButton from '../new-pages/Backbutton';
import { CircularProgress } from '@mui/material';
import { apiHandler } from '../../utils/apiHandler';
import { useNavigate } from 'react-router-dom';
function CustomVideoPlayer() {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const settingsRef = useRef(null); // Reference for the settings menu
  const [id, setId] = useState("");
  const [slug, setSlug] = useState("");
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(1);
  const [fullscreen, setFullscreen] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showControls, setShowControls] = useState(true);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [videoQuality, setVideoQuality] = useState('720p');
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [loading, setLoading] = useState(true);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const [videoSources, setVideoSources] = useState({});
  const [bufferedTime, setBufferedTime] = useState(0);
  const pathArray = window.location.pathname.split("/").filter(Boolean);
  // const videoSources = {
  //   '360p': 'https://videos.pexels.com/video-files/3343679/3343679-sd_640_360_30fps.mp4',
  //   '720p': 'https://lh3.googleusercontent.com/pw/AP1GczNhCCL4PfLSE1iNGnL0vtYh4BhpmdQCSMpR13OsIrmjS9jNqDCI3TIaPlmJmiz5mwgNuiTTctakMx5L0eEzeug9BEsFG-X4qNmdf3xxfeyL6agFNOI=m18',
  //   '1080p': 'https://lh3.googleusercontent.com/pw/AP1GczNhCCL4PfLSE1iNGnL0vtYh4BhpmdQCSMpR13OsIrmjS9jNqDCI3TIaPlmJmiz5mwgNuiTTctakMx5L0eEzeug9BEsFG-X4qNmdf3xxfeyL6agFNOI=32',
  // };
  const state = window.history.state;
  console.log(state?.title)
  useEffect(() => {


    const pathSegments = window.location.pathname.split("/");
    console.log(pathSegments)
    const extractedId = pathSegments[3];   // index 2 = id
    const extractedSlug = decodeURIComponent(pathSegments[4]); // index 3 = slug

    setId(extractedId);
    setSlug(extractedSlug);

  }, []);

  // const hasFetched = useRef(false); // remove if not needed or reset it on id change. 
  // Actually, keeping hasFetched ref might prevent double calls in strict mode, but let's just rely on useEffect dependencies correctly.

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        setLoading(true);
        if (id) {
          // id is the Google Photos Album ID from URL
          const AlbumLink = `https://photos.app.goo.gl/${id}`;

          try {
            const res = await apiHandler.post("/event/fetch-album", {
              url: AlbumLink,
            });

            if (res && res.length > 0 && !videoSources?.['360p']) {
              console.log(res[0]);
              setVideoSources({
                '360p': `${res[0]}=m18`,
                '720p': `${res[0]}=m22`,
                '1080p': `${res[0]}=m37`,
              });
            }
          } catch (error) {
            console.error("Failed to fetch album:", AlbumLink, error);
          }
        }
        setLoading(false);
      } catch (err) {
        console.error("Fetch video error:", err);
        setLoading(false);
      }
    };

    // Only fetch if we have an ID and haven't set sources yet
    if (id && !videoSources?.['360p']) {
      fetchVideo();
    }
  }, [id, videoSources]);

  // Ensure playing state is true when video source is set (since autoPlay is true)
  // Ensure playing state is true when video source is set (since autoPlay is true)
  useEffect(() => {
    if (videoSources?.['360p']) {
      setPlaying(true);
      // Explicitly attempt to play
      if (videoRef.current) {
        const playPromise = videoRef.current.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log("Autoplay with sound failed, attempting muted autoplay:", error);
            // Fallback to muted autoplay
            setMuted(true);
            if (videoRef.current) {
              videoRef.current.muted = true;
              videoRef.current.play().catch(e => {
                console.error("Autoplay muted failed:", e);
                setPlaying(false);
              });
            }
          });
        }
      }
    }
  }, [videoSources]);

  const handleProgress = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.buffered.length > 0) {
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      setBufferedTime(bufferedEnd); // Update how much is buffered
    }
  };

  console.log(videoSources?.['360p'])

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setFullscreen(false);
      } else {
        setFullscreen(true);
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);


  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    const handleMetadata = () => {
      setDimensions({
        width: video.videoWidth,
        height: video.videoHeight,
      });
    };

    // Listen for the metadata loaded event
    video.addEventListener('loadedmetadata', handleMetadata);

    return () => {
      // Clean up event listener
      video.removeEventListener('loadedmetadata', handleMetadata);
    };
  }, [videoSources, videoSources[videoQuality]]);



  const checkDeviceAndOrientation = () => {
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
    setIsMobile(isMobileDevice);
  };

  useEffect(() => {
    checkDeviceAndOrientation();
    window.addEventListener('resize', checkDeviceAndOrientation);

    // Clean up on component unmount
    return () => window.removeEventListener('resize', checkDeviceAndOrientation);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    video.addEventListener('progress', handleProgress);
    // Add event listeners for play and pause
    video.addEventListener('play', () => setPlaying(true));
    video.addEventListener('pause', () => setPlaying(false));

    // Close settings when clicking outside of the settings menu
    const handleClickOutside = (event) => {
      if (settingsOpen && !containerRef.current.contains(event.target) && !settingsRef.current.contains(event.target)) {
        setSettingsOpen(false);
        setActiveSubmenu(null);
      }
    };

    const handleMouseMoveOutside = (event) => {
      if (settingsOpen && !containerRef.current.contains(event.target) && !settingsRef.current?.contains(event.target)) {
        setSettingsOpen(false);
        setActiveSubmenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('mousemove', handleMouseMoveOutside);

    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('play', () => setPlaying(true));
      video.removeEventListener('pause', () => setPlaying(false));
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('mousemove', handleMouseMoveOutside);
      video.removeEventListener('progress', handleProgress);

    };
  }, [videoSources, settingsOpen]);

  const handlePlayPause = () => {
    if (playing) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setPlaying(!playing);
  };

  const handleNext = () => {

  };

  const handleMute = () => {
    setMuted(!muted);
    videoRef.current.muted = !muted;
  };

  const handleVolumeChange = (e) => {
    setVolume(e.target.value);
    videoRef.current.volume = e.target.value;
  };




  const handleFullscreenToggle = () => {
    if (fullscreen) {
      document.exitFullscreen();
      // Unlock orientation when exiting fullscreen
      if (window.screen.orientation.unlock) {
        window.screen.orientation.unlock();
      }
    } else {
      containerRef.current.requestFullscreen();
      // Lock orientation to landscape when entering fullscreen
      if (window.screen.orientation.lock) {
        window.screen.orientation.lock('landscape').catch((error) => {
          console.error('Failed to lock orientation:', error);
        });
      }
    }
    setFullscreen(!fullscreen);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(videoRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(videoRef.current.duration);
    setLoading(false)
  };

  const handleSeek = (e) => {
    const newTime = Number(e.target.value);
    const video = videoRef.current;

    video.currentTime = newTime;

    // Show loader immediately on seek
    setLoading(true);

    // If user clicks past buffered area, keep loader shown
    if (video.buffered.length > 0) {
      const lastBuffered = video.buffered.end(video.buffered.length - 1);
      if (newTime > lastBuffered - 0.3) {
        setLoading(true);
      }
    }

    const handleCanPlay = () => {
      setLoading(false);
      video.removeEventListener("canplay", handleCanPlay);
    };

    video.addEventListener("canplay", handleCanPlay);
  };


  const handleMouseMove = () => {
    setShowControls(true);
    clearTimeout(containerRef.current.hideTimeout);
    containerRef.current.hideTimeout = setTimeout(() => setShowControls(false), 3000);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const handlePlaybackSpeedChange = (speed) => {
    setPlaybackSpeed(speed);
    videoRef.current.playbackRate = speed;
    setSettingsOpen(false); // Close the settings after selecting speed
    setActiveSubmenu(null); // Reset active submenu
  };

  const handleQualityChange = (quality) => {
    setLoading(true)
    const currentVideoTime = videoRef.current.currentTime; // Store current time before changing quality
    setVideoQuality(quality);
    videoRef.current.src = videoSources[quality]; // Update video source

    // Load the new video source and listen for metadata load to play from current time
    videoRef.current.load();

    const handleLoadedMetadata = () => {
      videoRef.current.currentTime = currentVideoTime; // Set current time
      videoRef.current.play(); // Start playing the new video
      videoRef.current.removeEventListener('loadedmetadata', handleLoadedMetadata); // Clean up the event listener
    };

    videoRef.current.addEventListener('loadedmetadata', handleLoadedMetadata); // Add listener for loadedmetadata

    setSettingsOpen(false); // Close the settings after selecting quality
    setActiveSubmenu(null); // Reset active submenu

  };


  const handleDownload = async () => {
    try {
      const videoUrl = videoSources[videoQuality];

      // Check if the video URL is valid
      if (!videoUrl) {
        throw new Error("Invalid video URL");
      }

      // Fetch the video file
      const response = await fetch(videoUrl);

      if (!response.ok) {
        throw new Error("Failed to fetch video");
      }

      // Create a blob from the video file
      const blob = await response.blob();

      // Create a temporary link element
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.setAttribute('download', `video-${videoQuality}.mp4`); // Specify the file name

      // Append the link, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Revoke the object URL after download
      URL.revokeObjectURL(url);

    } catch (error) {
      alert("Can't download video: " + error.message);
    }
  };

  useEffect(() => {
    const isMobile = window.innerWidth <= 768; // Example breakpoint for mobile

    if (isMobile && showControls) {
      const timeout = setTimeout(() => {
        setShowControls(false);
      }, 5000);

      return () => clearTimeout(timeout); // Cleanup on unmount
    }
  }, [showControls]);




  const handleSettingsClick = (event) => {
    event.stopPropagation(); // Prevent the click event from bubbling up
    setSettingsOpen(!settingsOpen);
    setActiveSubmenu(null); // Close any active submenus when toggling settings
  };

  const renderQualityOptions = () => (
    <div className="absolute bottom-12 right-4 bg-gray-800 text-white p-4 rounded shadow-lg w-48">
      <h3 className="font-bold mb-2">Quality</h3>
      {['360p', '720p', '1080p'].map((quality) => (
        <button
          key={quality}
          onClick={() => handleQualityChange(quality)}
          className={`text-sm w-full text-left px-2 py-1 rounded mb-2 ${videoQuality === quality ? 'bg-red-600' : 'bg-gray-600'}`}
        >
          {quality}
        </button>
      ))}
    </div>
  );

  const renderSettingsMenu = () => (
    <div ref={settingsRef} className="absolute bottom-12 right-4 bg-gray-800 text-white p-4 rounded shadow-lg w-48">
      <h3 className="font-bold mb-2">Settings</h3>
      <button
        onClick={() => setActiveSubmenu('quality')}
        className="text-sm w-full text-left px-2 py-1 rounded flex justify-between items-center bg-gray-700 hover:bg-gray-600 mb-2"
      >
        Quality: {videoQuality}
      </button>
      <button
        onClick={() => setActiveSubmenu('speed')}
        className="text-sm w-full text-left px-2 py-1 rounded flex justify-between items-center bg-gray-700 hover:bg-gray-600 mb-2"
      >
        Speed: {playbackSpeed}x
      </button>
      {/* <button
        onClick={handleDownload}
        className="mt-2 bg-red-600 text-white px-2 py-1 rounded w-full flex items-center"
      >
        <FontAwesomeIcon icon={faDownload} className="mr-1" />
        Download
      </button> */}
    </div>
  );

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.close();
    }
  };

  useEffect(() => {
    console.log(showControls);
  }, [showControls])

  return (
    <div style={{ zIndex: '333333', backgroundColor: 'black', height: '100vh', height: viewportHeight }} className='m-0 p-0 main-video-container'>
      <div
        ref={containerRef}
        className="relative  videoplayer-container mx-auto bg-black h-full flex justify-center items-center "
        // onClick={() => { setShowControls(true) }}
        onMouseMove={handleMouseMove}
      // onTouchStart={() => setShowControls(!showControls)} 
      // onMouseLeave={() => setShowControls(false)}

      >
        <video
          ref={videoRef}
          className="w-full h-full  "
          style={{ height: isMobile ? dimensions.height : '', width: isMobile ? dimensions.width : '' }}
          src={videoSources[videoQuality]}
          // poster="https://via.placeholder.com/640x360.png?text=Video+Poster"
          onClick={() => { setShowControls(!showControls); setActiveSubmenu(null) }} // Keep this for desktop
          // onTouchStart={() => setShowControls(!showControls)} 
          muted={muted}
          autoPlay={true}
          onError={() => {
            if (videoQuality === "360p") setVideoQuality("360p");
            else if (videoQuality === "720p") setVideoQuality("720p");
            else if (videoQuality === '1080p') setVideoQuality("1080p");
            else console.error("All video sources failed.");
          }}
        ></video>
        <div
          className="absolute inset-0 pointer-events-none"
          onClick={() => setShowControls(!showControls)}
          style={{
            background: showControls ? 'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.04) 50%, rgba(0,0,0,0.7) 100%)' : 'transparent'
          }}
        ></div>
        {
          showControls && (
            <div onClick={() => setShowControls(!showControls)} className={`w-full   left-16 text-white absolute top-6   p-1 transition-opacity duration-300 ${showControls ? '' : 'opacity-0'}`}  >
              <div className="flex justify-center items-center w-full gap-12 title-pc" >
                {(fullscreen === false) && <div className="ourstory blessings">
                  <BackButton onClick={handleBack} className="pb-0 p-0 mb-0 m-0 ">
                    <svg
                      className={`arrowsvg`}
                      style={{
                        height: "5.2vh",
                        borderRadius: "50%",
                        zIndex: 999999,
                        overflow: "hidden",
                        padding: "0",
                        margin: 0,
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="2 2 20 20"
                    >
                      <style type="text/css">{`.st0{fill:#010101;}`}</style>
                      <path
                        className="st0"
                        d="M12,1.2C6,1.2,1.2,6,1.2,12C1.2,18,6,22.8,12,22.8S22.8,18,22.8,12C22.8,6,18,1.2,12,1.2z M19.1,12.6
    c-0.2,0.2-0.4,0.3-0.6,0.3H8.6l4.3,4.3c0.2,0.2,0.3,0.4,0.2,0.6c0,0.2-0.1,0.4-0.3,0.6c-0.2,0.2-0.4,0.2-0.6,0.2
    c-0.2,0-0.4-0.1-0.6-0.2l-5.8-5.8c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3
    l5.8-5.8c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6l-4.3,4.3h9.8
    c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6S19.2,12.5,19.1,12.6z"
                      />
                    </svg>
                  </BackButton>
                </div>}
                <p
                  style={{ fontSize: "5.5vh", color: 'white', fontFamily: 'Baby Givoni', width: '100%' }}
                >
                  {(state?.title || slug)}
                </p>
              </div>
            </div>
          )
        }
        {
          showControls && <div onClick={() => setShowControls(!showControls)} className={`w-full  hide-in-pc-title  text-white absolute top-6   p-1 transition-opacity duration-300 ${showControls ? '' : 'opacity-0'}`}  >   <p
            style={{ fontSize: "30px", color: 'white', fontFamily: 'Baby Givoni', width: '100%', textAlign: 'center', margin: '0' }}
          >
            {(state?.title || slug)}
          </p></div>
        }
        {
          loading &&
          <div
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 focus:outline-none text-white bg-black/0 text-3xl p-3 whiteripple"
            style={{ zIndex: '1111111' }}
          >
            <CircularProgress color="inherit" />
          </div>
        }
        {/* Play/Pause Button in Center of Video */}
        {showControls && (
          <button
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 focus:outline-none text-white bg-black/50 text-3xl p-3 whiteripple"
            onClick={handlePlayPause}
            disabled={loading}
            style={{ height: '100px', width: '100px', borderRadius: '100%', fontSize: '45px', paddingLeft: playing ? '300px' : '250px' }}
          >
            <FontAwesomeIcon icon={playing ? faPause : faPlay} size="3xl" style={{ paddingLeft: playing ? '' : '7px' }} />
          </button>
        )}

        {/* Rest of the code remains the same */}

        {/* Custom Controls */}
        <div

          className={`absolute bottom-0 w-full flex flex-col p-2 transition-opacity duration-300 ${showControls ? '' : 'opacity-0'}`}
        >
          {/* Progress Bar */}
          <div className="flex items-center mb-2 px-2 md:px-4  ">
            <div className="relative w-full h-1 bg-gray-500/40 rounded overflow-hidden">

              {/* Buffered Bar */}
              <div
                className="absolute top-0 left-0 h-full bg-gray-400 rounded"
                style={{ width: `${(bufferedTime / duration) * 100}%` }}
              ></div>

              {/* Watched Bar */}
              <div
                className="absolute top-0 left-0 h-full bg-red-500 rounded"
                style={{ width: `${(currentTime / duration) * 100}%` }}
              ></div>

              <input
                type="range"
                min="0"
                max={duration}
                value={currentTime}
                onChange={handleSeek}
                className="absolute inset-0 cursor-pointer opacity-0"
              />
            </div>

          </div>

          {/* Control Buttons */}
          <div className="flex items-center justify-between w-full px-2 md:px-4 space-x-4 text-white bottom-control">
            {/* Left Controls */}
            <div className="flex items-center space-x-4  control-gap">
              {/* Play/Pause Button */}
              <button onClick={handlePlayPause} disabled={loading} className="focus:outline-none w-[20px] ml-[10px] whiteripple " >
                <FontAwesomeIcon icon={playing ? faPause : faPlay} size="xl" />
              </button>
              {/* Next Button */}
              <button onClick={handleNext} className="focus:outline-none w-[20px] whiteripple">
                <FontAwesomeIcon icon={faForwardStep} size="xl" />
              </button>
              {/* Mute Button */}
              <button onClick={handleMute} className="focus:outline-none whiteripple p-1">
                <FontAwesomeIcon icon={muted ? faVolumeMute : faVolumeUp} size="xl" />
              </button>
              {/* Current Time / Duration */}
              <div className="flex items-center space-x-1 text-xl" >
                <span className='min-w-[50px]' >{formatTime(currentTime)}</span>
                <span>/</span>
                <span>{formatTime(duration)}</span>
              </div>
            </div>

            {/* Right Controls */}
            <div className="flex items-center space-x-4">
              {/* Volume Slider */}

              {/* Settings Button */}
              <button onClick={handleSettingsClick} className="focus:outline-none p-1 whiteripple" >
                <FontAwesomeIcon icon={faCog} size="xl" />
              </button>
              {/* Fullscreen Button */}
              <button onClick={handleFullscreenToggle} className="focus:outline-none p-1 whiteripple">
                <FontAwesomeIcon icon={fullscreen ? faCompress : faExpand} size="xl" />
              </button>
            </div>
          </div>
        </div>

        {/* Settings Menu or Quality Options */}
        {settingsOpen && !activeSubmenu && renderSettingsMenu()}
        {activeSubmenu === 'quality' && renderQualityOptions()}
        {activeSubmenu === 'speed' && (
          <div className="absolute bottom-12 right-4 bg-gray-800 text-white p-4 rounded shadow-lg w-48">
            <h3 className="font-bold mb-2">Speed</h3>
            {[0.5, 1, 1.5, 2].map((speed) => (
              <button
                key={speed}
                onClick={() => handlePlaybackSpeedChange(speed)}
                className={`text-sm w-full text-left px-2 py-1 mb-2 rounded ${playbackSpeed === speed ? 'bg-red-600' : 'bg-gray-600'}`}
              >
                {speed}x
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomVideoPlayer;
